'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rIC = require('./rIC');

var _rIC2 = _interopRequireDefault(_rIC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var usePolyfill = !window.requestIdleCallback;

/**
 * requestIdleCallback polyfill.
 */

exports.default = function (fn) {
    var callbackId = void 0;

    var throttled = function throttled() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var latestArgs = args;
        // If we have already requested an animation frame, return
        if (callbackId) return;

        // Wait an animation frame
        callbackId = (0, _rIC2.default)(function () {
            callbackId = null;
            fn.apply(undefined, latestArgs);
        });
    };

    throttled.cancel = function () {
        if (!callbackId) return;
        usePolyfill ? clearTimeout(callbackId) : window.cancelIdleCallback(callbackId);
        callbackId = null;
    };

    return throttled;
};


//////////////////
// WEBPACK FOOTER
// ./src/common/utils/lib/rICThrottle.js
// module id = 2296
// module chunks = 0